module.exports = __webpack_public_path__ + "img/quality-target.45d1236d.png";